import BaseService from './base.service'
const API_URL = process.env.VUE_APP_API_URL

class TicketService extends BaseService {
    ticketDetails(reference: string) {
        return this.get(API_URL + `api/ticket/detail/${reference}`).then((response) => {
            return response.data
        })
    }

    ticketValidation(reference: string) {
        return this.post(API_URL + `api/ticket/settle/${reference}`, {}).then((response) => {
            return response.data
        })
    }
}

export default new TicketService()
